module.exports = __webpack_public_path__ + "static/media/iso-success.34ccb19e.svg";